module.exports = __webpack_public_path__ + "static/media/c-balanced.df49a9d9.jpg";